import React from "react";
import { useCurrentRefinements } from "react-instantsearch";

const FACET_LABELS = {
  docType: "Type de document",
  fonds: "Fonds",
  lieu: "Lieux",
  auteur: "Auteurs",
  avmat: "CDU",
  emission: "Émissions",
  genre: "Genre / Forme",
  sujet: "Sujets",
  editeur: "Éditeur",
  physicLoc: "Localisation",
  sponsor: "Sponsor",
  partenaire: "Partenaire",
  access: "Accès",
  typeDocument: "Type doc.",
  typeMedia: "Média",
  typeSupport: "Support",
  rdaPolarity: "Polarité",
  colorContent: "Couleur",
  langue: "Langue",
  collaborateurs: "Collaborateur",
};
const DOC_TYPE_LABELS = { k: "Photographie", v: "Film/Vidéo", s: "Audio" };

const VALUE_LABEL_MAP = {
  "memoriav": "Memoriav",
  "loterie": "Loterie Romande",
  "rsr": "Radio Suisse Romande",
  "interregIV": "Interreg VIA Archivalp",
  "interregIIIa": "Interreg IIIA E.CH.I.",
  "Le pour-cent culture": "Le pour-cent culturel",
  "Fondation Pierre Gia": "Fondation Pierre Gianadda",
  "OFC": "Office Fédéral de la Culture",
  "Tout public": "Online",
  "MV": "Sur place",
};

export default function CustomCurrentRefinements() {
  const { items, refine } = useCurrentRefinements();

  if (!items || items.length === 0) return null;

  return (
    <div className="ais-CurrentRefinements">
      <ul className="cr-list">
        {items.map((item) => (
          <li key={item.label} className="ais-CurrentRefinements-item">
            <span className="ais-CurrentRefinements-category">
              {FACET_LABELS[item.attribute] || item.label}
            </span>
            {item.refinements.map((refinement) => {
              let display = refinement.label;
              const isExclude = display.startsWith("NOT:");
              if (isExclude) display = display.slice(4);
              else if (item.attribute === "docType" && DOC_TYPE_LABELS[display]) {
                display = DOC_TYPE_LABELS[display];
              } else if (["lieu", "genre", "sujet"].includes(item.attribute) && display.includes("|")) {
                display = display.split("|")[1];
              } else if (VALUE_LABEL_MAP[display]) {
                display = VALUE_LABEL_MAP[display];
              }

              return (
                <span
                  key={refinement.label}
                  className={`ais-CurrentRefinements-label ${isExclude ? "ais-CurrentRefinements-label--exclude" : "ais-CurrentRefinements-label--include"}`}
                >
                  {isExclude && <span className="ais-CurrentRefinements-prefix">−</span>}
                  <span className="ais-CurrentRefinements-categoryLabel">
                    {display}
                  </span>
                  <button
                    type="button"
                    className="ais-CurrentRefinements-delete"
                    onClick={() => refine(refinement)}
                  >
                    ✕
                  </button>
                </span>
              );
            })}
          </li>
        ))}
      </ul>
    </div>
  );
}
